(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pack-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pack-quantity')) {
    window.__packQty = window.__packQty || {};

    class PackQuantity extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-pack-variants]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.inputs = Array.from(this.querySelectorAll('.pack-qty__input'));
        this.money = new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        });

        this.handleCardChange = (event) => {
          if (event.target.matches('.pack-qty__input')) this.select(Number(event.target.value));
        };
        // Recharge's widget updates its selling plan input asynchronously, so refresh a beat later
        this.handleExternal = () => setTimeout(() => this.refresh(), 40);
        // Some themes reset the qty input after add-to-cart; re-apply the selected pack
        this.handleCartUpdate = () => setTimeout(() => this.applyQuantity(), 60);

        this.addEventListener('change', this.handleCardChange);
        document.addEventListener('change', this.handleExternal);
        document.addEventListener('click', this.handleExternal);
        document.addEventListener('variant:update', this.handleExternal);
        document.addEventListener('cart:update', this.handleCartUpdate);

        // Recharge renders and re-renders its widget client-side; re-sync prices when it does.
        // All writes below are no-ops when nothing changed, so this can't loop.
        this.observer = new MutationObserver(() => {
          clearTimeout(this.syncTimer);
          this.syncTimer = setTimeout(() => this.refresh(), 50);
        });
        this.observer.observe(this.scope === document ? document.body : this.scope, {
          childList: true,
          subtree: true,
          characterData: true,
        });

        // Recharge's widget is a custom element that renders after its script loads
        customElements.whenDefined('recharge-subscription-widget').then(() => {
          setTimeout(() => this.refresh(), 100);
          setTimeout(() => this.refresh(), 600);
        });

        // Keep the selection when the theme re-renders the section on flavor change
        this.select(window.__packQty[this.dataset.productId] || 1);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleCardChange);
        document.removeEventListener('change', this.handleExternal);
        document.removeEventListener('click', this.handleExternal);
        document.removeEventListener('variant:update', this.handleExternal);
        document.removeEventListener('cart:update', this.handleCartUpdate);
        this.observer?.disconnect();
        clearTimeout(this.syncTimer);
      }

      get scope() {
        return this.closest('.product-details') || document;
      }

      get form() {
        return (
          this.scope.querySelector('form[data-type="add-to-cart-form"]') ||
          document.querySelector('form[data-type="add-to-cart-form"]')
        );
      }

      select(qty) {
        const input = this.inputs.find((el) => Number(el.value) === qty) || this.inputs[0];
        if (!input) return;
        this.qty = Number(input.value);
        input.checked = true;
        window.__packQty[this.dataset.productId] = this.qty;
        this.applyQuantity();
        this.refresh();
      }

      applyQuantity() {
        const qtyInput = this.form?.elements.namedItem('quantity');
        if (!qtyInput || String(qtyInput.value) === String(this.qty)) return;
        qtyInput.value = this.qty;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /*
        Multiplies the prices shown inside Recharge's widget by the selected pack count.
        Recharge renders inside a shadow root with Lit, so this walks into shadow roots
        and edits text nodes in place (never replaces elements, which would break Lit).
        Each node remembers its unit price, so re-runs never compound, and if Recharge
        rewrites a price itself (plan or flavor change) it's picked up fresh.
      */
      syncWidgetPrices(variant) {
        if (this.dataset.syncWidget !== 'true') return;

        let hosts = [];
        try {
          hosts = Array.from(this.scope.querySelectorAll(this.dataset.widgetSelector || '.shopify-app-block'));
        } catch (error) {
          return; // invalid selector in settings
        }
        hosts = hosts.filter((host) => !host.contains(this) && !this.contains(host));
        if (!hosts.length) return;

        this.textMarks = this.textMarks || new WeakMap();
        this.watchedRoots = this.watchedRoots || new WeakSet();

        const format = (cents) => this.money.format(cents / 100);
        const unitPrices = new Map();
        [variant.price, variant.compare, ...Object.values(variant.plans)].forEach((cents) => {
          if (cents) unitPrices.set(format(cents), cents);
        });

        // Collect the host plus every open shadow root beneath it
        const trees = [];
        const collect = (root) => {
          trees.push(root);
          root.querySelectorAll('*').forEach((el) => {
            if (el.shadowRoot) {
              if (!this.watchedRoots.has(el.shadowRoot)) {
                this.watchedRoots.add(el.shadowRoot);
                this.observer?.observe(el.shadowRoot, { childList: true, subtree: true, characterData: true });
              }
              collect(el.shadowRoot);
            }
          });
        };
        hosts.forEach(collect);

        trees.forEach((tree) => {
          const walker = document.createTreeWalker(tree, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            const text = node.data.trim();
            if (!text || text.length > 24 || !/\d/.test(text)) continue;

            const mark = this.textMarks.get(node);
            let unit;
            if (mark && mark.written === text) {
              unit = mark.unit; // ours, still intact
            } else if (unitPrices.has(text)) {
              unit = unitPrices.get(text); // fresh price from Recharge
            } else {
              this.textMarks.delete(node);
              continue;
            }

            const next = format(unit * this.qty);
            this.textMarks.set(node, { unit, written: next });
            if (text !== next) node.data = node.data.replace(text, next);
          }
        });
      }

      currentVariant() {
        const id = this.form?.elements.namedItem('id')?.value;
        return this.variants.find((v) => String(v.id) === String(id)) || this.variants[0];
      }

      currentPlanId() {
        const field =
          this.form?.elements.namedItem('selling_plan') || this.scope.querySelector('[name="selling_plan"]');
        return field ? field.value : '';
      }

      refresh() {
        const variant = this.currentVariant();
        if (!variant) return;

        const planId = this.currentPlanId();
        const unitPrice = planId && variant.plans[planId] != null ? variant.plans[planId] : variant.price;
        const format = (cents) => this.money.format(cents / 100);

        this.inputs.forEach((input) => {
          const packs = Number(input.value);
          const card = input.closest('.pack-qty__card');
          const unavailable = !variant.available || (variant.limited && packs > variant.inventory);

          input.disabled = unavailable;
          card.classList.toggle('is-disabled', unavailable);

          const priceEl = card.querySelector('[data-pack-price]');
          if (priceEl) {
            const full = variant.price * packs;
            const total = unitPrice * packs;
            const html = total < full ? `<s>${format(full)}</s>${format(total)}` : format(total);
            if (priceEl.dataset.html !== html) {
              priceEl.innerHTML = html;
              priceEl.dataset.html = html;
            }
          }
        });

        this.syncWidgetPrices(variant);

        const selected = this.inputs.find((el) => Number(el.value) === this.qty);
        if (selected?.disabled) {
          const fallback = this.inputs.find((el) => !el.disabled);
          if (fallback && Number(fallback.value) !== this.qty) this.select(Number(fallback.value));
        }
      }
    }

    customElements.define('pack-quantity', PackQuantity);
  }
  } catch(e) { console.error(e); }
})();

})();
